import React from 'react';
import { ImageFile } from '~/data/types/images';

const TradeInPromotionTopCardIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 445 349"
    >
      <path
        d="M7.00056 6.85855C74.3581 186.922 226.863 203.813 256.541 122.211C258.753 116.129 259.768 109.56 259.463 103.096C256.417 38.3808 166.773 52.846 153.605 145.218C134.105 282.01 250.715 355.185 438.129 340.736"
        stroke="#00D6D1"
        strokeWidth={12.44}
        strokeLinecap="round"
      />
    </Component>
  );
};

export default TradeInPromotionTopCardIcon;
